import { Component, inject, OnInit } from '@angular/core';
import { IAccessTicketVm } from '../../../../api/access-ticket-vm.model';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { CommonModule } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  selector: 'app-qrcode-details',
  standalone: true,
  imports: [CommonModule, QRCodeModule],
  templateUrl: './qrcode-details.component.html',
  styleUrl: './qrcode-details.component.scss'
})
export class QrcodeDetailsComponent implements OnInit{

  public data!: IAccessTicketVm;

  private _dialogConfig = inject(DynamicDialogConfig);

  ngOnInit() {
    this.data = this._dialogConfig.data as IAccessTicketVm;
  }

    buildSignUpUrl(code: string): string {
    return `https://zdamyprawko.pl/app/sign-up?code=${code}`;
  }
}
